/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_OptionsInputs */

const en_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Options`)
};

const fr_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options de traduction`)
};

const de_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungsoptionen`)
};

const it_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di traduzione`)
};

const ru_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры перевода`)
};

const es_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de traducción`)
};

const zh_cn2_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译选项`)
};

const ja_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳オプション`)
};

const hi_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद विकल्प`)
};

const pt_pt2_translation_options = /** @type {(inputs: Translation_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de tradução`)
};

/**
* | output |
* | --- |
* | "Translation Options" |
*
* @param {Translation_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_options = /** @type {((inputs?: Translation_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_options(inputs)
	if (locale === "de") return de_translation_options(inputs)
	if (locale === "it") return it_translation_options(inputs)
	if (locale === "ru") return ru_translation_options(inputs)
	if (locale === "es") return es_translation_options(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_options(inputs)
	if (locale === "ja") return ja_translation_options(inputs)
	if (locale === "hi") return hi_translation_options(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_options(inputs)
	return en_translation_options(inputs)
});